import { AuthBody, RegAuthBody } from 'models/AuthBody';

export const isAuthBody = (response: any): response is AuthBody =>
  response &&
  response.tokens !== undefined &&
  typeof response.tokens.accessToken === 'string' &&
  response.user !== undefined;

export const isRegAuthBody = (response: any): response is RegAuthBody =>
  response &&
  typeof response.registrationToken === 'string' &&
  response.user !== undefined;
